/* "Idiomas" (A and 文) in the stroke of the other account icons; not the globe, which is Domínios' in the sidebar */
export const LangIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#5E6272"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="m5 8 6 6" />
    <path d="m4 14 6-6 2-3" />
    <path d="M2 5h12" />
    <path d="M7 2h1" />
    <path d="m22 22-5-10-5 10" />
    <path d="M14 18h6" />
  </svg>
);
